import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {AgentTasksAppPayload} from '@github-ui/agent-sessions/types/agent-tasks-app-payload'

import {copilotAgentsAppBuilder} from '../config/app-builder'
import {copilotChatPayloadRouteQuery} from './copilot-chat-payload-route-query'

export function createCopilotAgentsConversationRoute(path: string) {
  return copilotAgentsAppBuilder.createQueryRouteConfig('copilotAgentsConversationRoute', {
    path,
    queries: [mainQuery<AgentTasksAppPayload>(), copilotChatPayloadRouteQuery],
  })
}

export const copilotAgentsConversationRoute = createCopilotAgentsConversationRoute('/copilot/agents/c/:threadID')
export const canonicalCopilotAgentsConversationRoute = createCopilotAgentsConversationRoute('/copilot/c/:threadID')
